"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Checkroom = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("g", { fillRule: "evenodd" },
            React.createElement("path", { d: "M12.5,4 C13.84836,4 15,5.06584648 14.9996866,6.48230002 C15.0292745,7.31759275 14.705897,7.82393412 13.9701075,8.42230425 L13.608452,8.70411068 C13.1919087,9.02679688 13.0323897,9.21123071 13.0045681,9.42676942 L13,9.5 L12.9991454,10.255 L21.7839643,17.0874304 L21.9010125,17.2530611 C21.9725296,17.3627453 21.9923295,17.4286535 21.9703056,17.529934 L21.9461003,17.6137635 L21.8734243,17.8031097 L21.7593988,17.9060038 C21.6987656,17.9545089 21.6563808,17.9689551 21.5571294,17.9860801 L21.4708546,18 L3.52914536,18 L3.34942743,17.9459839 C3.15397071,17.8808846 3.11883418,17.8271256 3.0478345,17.5885235 L3.01914536,17.49 L3.04598077,17.3387755 C3.06406244,17.2632627 3.08864983,17.2258378 3.15648051,17.1513857 L3.21603565,17.0874304 L11.9991454,10.255 L12,9.49977124 C12.0002775,8.89325501 12.2606436,8.51049045 12.8435563,8.03465334 L13.1950683,7.7604856 C13.8151785,7.28182429 14.0174557,7.00164227 14,6.5 C14,5.63616611 13.3126267,5 12.5,5 C11.6729766,5 11,5.61533864 11,6.5 C11,6.77614237 10.7761424,7 10.5,7 C10.2238576,7 10,6.77614237 10,6.5 C10,5.0420759 11.1396859,4 12.5,4 Z M12.5,11.132 L4.955,17 L20.044,17 L12.5,11.132 Z", fillRule: "nonzero" }),
            React.createElement("path", { d: "M10,6.5 L11,6.5 C11,6.77614237 10.7761424,7 10.5,7 C10.2238576,7 10,6.77614237 10,6.5 L10,6.5 L10,6.5 Z" }))));
};
Checkroom.displayName = 'Checkroom';
exports.default = Checkroom;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Checkroom.js.map